// extracted by mini-css-extract-plugin
module.exports = {"avatar":"style_avatar__iLlRQ"};